// extracted by mini-css-extract-plugin
export default {"scapeView":"ScapeView_scapeView__mEQfQ","scapeInfo":"ScapeView_scapeInfo__vR8+w","deleteButton":"ScapeView_deleteButton__VDkG4"};